module.exports = __webpack_public_path__ + "img/no-power.76cca40c.png";